<template>
     <footer v-show="showFooter" class="footer footer--checkout">
        <div class="container container--fluid u-d-flex">
            <a @click="triggerNextStage" class="btn u-mx-auto">{{footerState.nextBtnText}}</a>
        </div>
    </footer>
</template>

<script>
export default {
    name: "CheckoutFooter",

    methods: {
        triggerNextStage: function() {
            this.$store.dispatch('checkout/triggerNextStage');
        }
    },
    computed: {
        stage() {
            return this.$store.state.checkout.stage;
        },
        footerState() {
            if(this.stage === 1) {
                return this.stages[0];
            }
            if(this.stage === 2) {
                return this.stages[1];
            }
            if(this.stage === 3) {
                return this.stages[2];
            }
            if(this.stage == 4) {
                return this.stages[3];
            }

            return { nextBtnText: 'Next'};
        },
        showFooter() {
            return this.stage > 0 && this.stage < 6;
        }
    },
    data: function(){
        return {
            nextText: "Select your date",
            stages:[
                {
                    nextBtnText:"Select your date",
                },
                {
                    nextBtnText:"Select your upgrades",
                },
                {
                    nextBtnText:"Review your order",
                },
                {
                    nextBtnText:"Make payment",
                }
            ]
        }
    }
}
</script>

<style>

</style>
